export default {
    PREPARE_GROUP_DATA: 'prepareGroupData',
    PREPARE_DEPARTMENT_TRANSFERS_DATA: 'prepareDepartmentTransfersData',
    SUBMIT_GROUP_FORM: 'submitGroupForm',
    SUBMIT_DEPARTMENT_TRANSFERS_FORM: 'submitDepartmentTransfersForm',
    REFRESH_GROUP_OPERATION: 'refreshGroupOperation',
    PREPARE_DOCUMENTS: 'prepareDocuments',
    DELETE_OPERATION: 'deleteOperation',
    PREVALIDATE_DELETE_OPERATION: 'prevalidateDeleteOperation',
    SAVE_OPERATION: 'saveOperation',
    STORE_SOURCE_TRANSFER_IN_CASH_REGISTER: 'storeSourceTransferInCashRegister',
    DESTROY_OPERATION_LOCK: 'destroyOperationLock',
    REFRESH_TITLE_FOR_OPERATIONS: 'refreshTitleForOperations',
    MARK_OPERATION_NOT_RECOGNISED: 'markOperationNotRecognised',
    STORE_NOT_RECOGNISED_OPERATION: 'storeNotRecognisedOperation',
    UPLOAD_STATEMENT_PDF: 'uploadStatementPdf',
}
